import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiFlowLabelComponent } from '../../atoms/flow-label/flow-label.component';
import { UiFlowNodeFrameComponent } from '../../atoms/flow-node-frame/flow-node-frame.component';

@Component({
  selector: 'ui-flow-decision-node',
  standalone: true,
  imports: [UiFlowNodeFrameComponent, UiFlowLabelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ui-flow-node-frame shape="diamond">
      <ui-flow-label [text]="label()" tone="strong" />
    </ui-flow-node-frame>
  `,
  styles: `
    :host {
      display: inline-flex;
      flex: 0 0 132px;
      width: 132px;
      height: 132px;
      align-items: center;
      justify-content: center;
    }
  `,
})
export class UiFlowDecisionNodeComponent {
  readonly label = input.required<string>();
}
